import React from 'react';
import css from './selfEmployed.module.scss';
import Chip from "@material-ui/core/Chip";
import selfEmployed from "../../../assets/images/projectsImage/self-employed.jpg";

const SelfEmployed: React.FC = () => (
    <div className={css.project} id="selfEmployed">
        <img src={selfEmployed} alt=""/>
        <div className={css.projectInformationContainer}>

            <div className={css.projectName} style={{position: 'relative'}}>
                <h3>Self Employed</h3>
            </div>

            <div className={css.infoSmallScreen}>
                <Chip label="Aug. 2020 - May. 2022" size='small' variant="outlined"/>
            </div>
            <div className={css.info}>
                <Chip label="Aug. 2020 - May. 2022" size='small' variant="outlined"/>
            </div>

        </div>
    </div>
);

export default SelfEmployed;
